import { List, ListItem, ListItemIcon, ListItemText, Typography } from "@mui/material";
import { Constants } from "../constants";
import CircleIcon from '@mui/icons-material/Circle';


export const StarBulletsPoints = ({ items }) => {
    return (
        <>

            <List>
                {items?.map((item, index) => (
                    <>
                        {
                            item?.isShow && <ListItem key={index} sx={{ alignItems: "flex-start" }}>
                                <ListItemIcon sx={{ minWidth: "30px", mt: "5px" }}>
                                    {/* <FiberManualRecordIcon sx={{ fontSize: 10, color: "text.secondary" }} /> */}
                                    <img src={Constants.customImages.StartBullet} width={"20px"} />
                                </ListItemIcon>
                                <ListItemText
                                    primary={
                                        <Typography variant="body2" color="grey.400" dangerouslySetInnerHTML={{ __html: item?.listitem }}  />

                                    }
                                />
                            </ListItem>
                        }
                    </>

                ))
                }
            </List>
        </>
    );
};


export const StarBulletsPointsWithHeading = ({ items, direction = "row" }) => {

    const isReverse = direction === "row-reverse";

    return (
        <List>
            {items?.map((item, index) => (
                <ListItem
                    key={index}
                    sx={{
                        alignItems: "flex-start",
                        display: "flex",
                        flexDirection: direction,
                        gap: "1rem",
                    }}
                >
                    <ListItemIcon
                        sx={{
                            minWidth: "35px",
                            mt: 0.8,
                        }}
                    >
                        <img src={Constants.customImages.StartBullet} width={"25px"} />
                    </ListItemIcon>

                    <ListItemText
                        primary={
                            <Typography
                                variant="h6"
                                dangerouslySetInnerHTML={{ __html: item?.listItemTitle }}
                                textAlign={isReverse ? "end" : "start"}
                            />
                        }
                        secondary={
                            <Typography
                                variant="body1"
                                color="grey.400"
                                fontWeight={300}
                                mt={1}
                                dangerouslySetInnerHTML={{ __html: item?.listItemContent }}
                                textAlign={isReverse ? "end" : "start"}
                            />
                        }
                    />
                </ListItem>
            ))}
        </List>
    );
};


export const DotBulletsPoints = ({ items, direction = "row", dotColor }) => {

    const isReverse = direction === "row-reverse";

    return (
        <List>
            {items?.map((item, index) => (
                <ListItem
                    key={index}
                    sx={{
                        alignItems: "flex-start",
                        display: "flex",
                        flexDirection: direction,
                        gap: "1rem",
                        p: 0,
                        m: 0
                    }}
                >
                    <ListItemIcon
                        sx={{
                            minWidth: "30px",
                            mt: 0.8,
                        }}
                    >
                        <CircleIcon sx={{ color: dotColor, fontSize: 18 }} />
                    </ListItemIcon>

                    <ListItemText
                        primary={
                            <Typography
                                variant="body1"
                                dangerouslySetInnerHTML={{ __html: item }}
                                textAlign={isReverse ? "end" : "start"}
                                fontWeight={300}
                            />
                        }
                    />
                </ListItem>
            ))}
        </List>
    );
};

export const DotBulletsWithoutPoints = ({ items, direction = "row", dotColor }) => {

    const isReverse = direction === "row-reverse";

    return (
        <List>
            {items?.map((item, index) => (
                <ListItem
                    key={index}
                    sx={{
                        alignItems: "flex-start",
                        display: "flex",
                        flexDirection: direction,
                        gap: "1rem",
                        p: 0,
                        m: 0
                    }}
                >
                    <ListItemText
                        primary={
                            <Typography
                                variant="body1"
                                dangerouslySetInnerHTML={{ __html: item }}
                                textAlign={isReverse ? "end" : "start"}
                                fontWeight={300}
                            />
                        }
                    />
                </ListItem>
            ))}
        </List>
    );
};
